import {ref} from 'vue';
type OnCloseCallback = () => void;

interface EditorDialogWarningsShowOptions {
	title: string;
	warnings: string[];
}

const DEFAULT = {
	title: 'no title',
	warnings: [] as string[],
};
export class EditorDialogWarningsStoreControllerClass {
	private static _instance: EditorDialogWarningsStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogWarningsStoreControllerClass());
	}

	private _displayed = ref(false);
	private _title = ref(DEFAULT.title);
	private _warnings = ref(DEFAULT.warnings);
	// private _resizable = ref(DEFAULT.resizable);
	// private _width = ref(DEFAULT.width);
	// private _height = ref(DEFAULT.height);
	private _on_close_callback: OnCloseCallback | undefined;
	private constructor() {}

	private _reset() {
		this._displayed.value = false;
		this._title.value = DEFAULT.title;
		this._warnings.value.splice(0, this._warnings.value.length);
		// this._resizable.value = DEFAULT.resizable;
		// this._width.value = DEFAULT.width;
		// this._height.value = DEFAULT.height;
	}

	displayed(): boolean {
		return this._displayed.value;
	}
	title(): string {
		return this._title.value;
	}
	warnings(): string[] {
		return this._warnings.value;
	}
	// resizable(): boolean {
	// 	return this._resizable.value;
	// }
	// width() {
	// 	return this._width.value;
	// }
	// height() {
	// 	return this._height.value;
	// }

	// mutations
	async show(options: EditorDialogWarningsShowOptions): Promise<void> {
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
			this._title.value = options.title;
			for (const warning of options.warnings) {
				this._warnings.value.push(warning);
			}
			// this._resizable.value = options.resizable || false;
			// this._width.value = options.width || DEFAULT.width;
			// this._height.value = options.height || DEFAULT.height;
			this._on_close_callback = resolve;
		});
	}
	hide() {
		this._reset();
		if (this._on_close_callback) {
			this._on_close_callback();
		}
	}
}

export const EditorDialogWarningsStoreController = EditorDialogWarningsStoreControllerClass.instance();
